import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { ActionsRequisesDtoActionsRequisesEnum } from 'lib_api/lib/api/gen';

import { DashboardJusticeFilterForm } from '../pages/justice/Dashboard/types';

interface JusticeFilterContextContent {
  filter: Partial<DashboardJusticeFilterForm>;
  setFilter: Dispatch<SetStateAction<Partial<DashboardJusticeFilterForm>>>;
  // all actions requises configured for justice users
  actionsRequises: ActionsRequisesDtoActionsRequisesEnum[] | undefined;
}

const JusticeFilterContext = createContext<JusticeFilterContextContent | null>(
  null,
);

export const useJusticeFilterContext = (): [
  Partial<DashboardJusticeFilterForm>,
  Dispatch<SetStateAction<Partial<DashboardJusticeFilterForm>>>,
  ActionsRequisesDtoActionsRequisesEnum[] | undefined,
] => {
  const context = useContext(JusticeFilterContext);
  if (context === null) {
    throw new Error('useFilterContext called outside Context.');
  }

  return [context.filter, context.setFilter, context.actionsRequises];
};

const JusticeFilterProvider = JusticeFilterContext.Provider;

export default JusticeFilterProvider;
